<template>
    <div>
        <div class="textContent" v-html="description" />

        <div v-if="productData.ingredientsText" class="textContent">
            <h2 class="textContent__h2">{{ $t('productDetail.ingredients') }}</h2>
            <div v-html="productData.ingredientsText" />
        </div>

        <div v-if="productData.categoryText" class="textContent">
            <p v-html="productData.categoryText"></p>
        </div>

        <div v-if="productData.seoText" class="textContent">
            <p v-html="productData.seoText"></p>
        </div>

        <div v-if="commentsCount === 0" class="rating-container row pb-4">
            <h2 class="my-3 text-center">
                {{ $t('rating.noRatings') }}
            </h2>
            <div class="row text-center">
                <div class="col-12">
                    <a class="btn btn-outline-primary" @click="$bus.$emit('showModal', 'modal-form-review')">
                        {{ $t('rating.writeRating') }}
                    </a>
                </div>
            </div>
        </div>

        <ProductServiceVariants :product-data="productData" />
    </div>
</template>

<script lang="ts">
import ProductServiceVariants from '~/components/layout/productDetail/ProductServiceVariants.vue'
import FullProduct from '~/models/Product/FullProduct'

export default {
    components: {
        ProductServiceVariants,
    },

    props: {
        productData: {
            type: Object as PropType<FullProduct>,
            required: true,
        },
        otherManufacturerServices: {
            type: Array,
            default() {
                return []
            },
        },
        description: {
            type: String,
            default() {
                return ''
            },
        },
        commentsCount: {
            type: Number,
            default: 0,
        },
    },
}
</script>

<style lang="scss">
.textContent {
    line-height: 1.5;

    h1,
    h2,
    h3 {
        margin-bottom: 0.7rem;
        margin-top: 1.8rem;
        font-family: 'scale-variable', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
            'Droid Sans', 'Helvetica Neue', sans-serif;
        font-variation-settings: 'wght' 700, 'wdth' 100;
    }
    h4 {
        margin-bottom: 1rem;
        margin-top: 1.3rem;
    }
    ul li {
        font-size: 16px;
        line-height: 24px;
        font-style: normal;
        list-style: none;
        position: relative;
        padding: 0;

        &::before {
            content: '';
            position: absolute;
            left: -20px;
            top: 10px !important;
            background: $color-purple;
            border-radius: 50%;
            width: 8px;
            height: 8px;
            border: 0;
        }
        &::after {
            display: none;
        }
    }

    table {
        width: 100% !important;
        border-collapse: collapse !important;
        border: 0 !important;
        text-align: left !important;
        padding: 0 !important;
        margin: 0 0 20px 0 !important;

        tr {
            border: 0 !important;
        }

        tr > * {
            background: #f2f2f2 !important;
            border: 1px solid $color-grey-dark !important;
            padding: 10px 5px !important;
        }

        td {
            border: 1px solid $color-grey-dark !important;
            padding: 10px 5px !important;
            background: transparent !important;
        }
    }
}

.rc-container .rc-u-know__ico__elem:after {
    // /wobenzym-800-tabliet cg
    top: 0;
    line-height: 52px;
}

.service--about {
    max-width: 900px;
    margin: 0 auto;
    overflow-x: hidden;
}

h3 {
    margin: 20px 0 20px;
}
</style>
